import './SupportPane.scss'
import { IconButton } from '@/ui-legacy'
import Templates from '../Templates/Templates'
import DataAssets from '../DataAssets/DataAssets'
import { SupportPaneSize } from '../App'
import { useFooterHeight } from '@/hooks'
import Glossary from '../Glossary/Glossary'
import ErrorBoundary from '@/ui-legacy/ErrorBoundary/ErrorBoundary'
import FAQ from '../FAQ/FAQ'

type SupportPaneProps = {
  supportPaneKey: string | undefined
  supportPaneSize: SupportPaneSize | undefined
  setSupportPaneSize: (size: SupportPaneSize | undefined) => void
  appId: number | null
}

function SupportPane({ supportPaneKey, supportPaneSize, setSupportPaneSize, appId }: SupportPaneProps) {
  const renderSupport = () => {
    switch (supportPaneKey) {
      case 'data-assets':
        return <DataAssets supportPaneSize={supportPaneSize} setSupportPaneSize={setSupportPaneSize} appId={appId} />

      case 'data-templates':
        return <Templates supportPaneSize={supportPaneSize} setSupportPaneSize={setSupportPaneSize} appId={appId} />

      case 'glossary':
        return <Glossary appId={appId} />
      case 'faq':
        return <FAQ appId={appId} />
      default:
        return <div>Support Pane Key not supported</div>
    }
  }

  const renderTitle = () => {
    switch (supportPaneKey) {
      case 'data-assets':
        return 'Data assets'
      case 'data-templates':
        return 'Templates'
      case 'glossary':
        return 'Glossary'
      case 'faq':
        return 'FAQ'
      default:
        return 'Support'
    }
  }

  const maximiseMinimise = () => {
    if (supportPaneSize === SupportPaneSize.Max) {
      setSupportPaneSize(SupportPaneSize.Min)
    }
    if (supportPaneSize === SupportPaneSize.Min) {
      setSupportPaneSize(SupportPaneSize.Max)
    }
  }

  const footerHeight = useFooterHeight()
  const headerHeight = 43

  return (
    <ErrorBoundary>
      <div className="ux-support-pane" style={{ height: `calc(100vh - ${footerHeight}px - ${headerHeight}px)` }}>
        <div className="support-pane-header">
          <div className="title">{renderTitle()}</div>
          <div className="action-container">
            <IconButton
              icon={supportPaneSize === SupportPaneSize.Max ? 'minimize-outline' : 'expand-outline'}
              onClick={maximiseMinimise}
            />
            <IconButton icon="close-outline" onClick={() => setSupportPaneSize(undefined)} />
          </div>
        </div>

        <>
          <div className="support-content">{renderSupport()}</div>
          <div className="support-footer" />
        </>
      </div>
    </ErrorBoundary>
  )
}

export default SupportPane
